<template>
  <div>
    <v-btn @click="dialog = true" icon color="warning"
      ><v-icon>mdi-pencil</v-icon></v-btn
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <ModalHeader
          title="Edit Item Type"
          icon="mdi-pencil"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-text-field
            outlined
            dense
            v-model="item.item_type"
            prepend-icon=""
            label="Item Type"
          ></v-text-field>
          <v-text-field
            outlined
            dense
            v-model="item.description"
            prepend-icon=""
            label="Description"
          ></v-text-field>
          <v-select
            outlined
            dense
            v-model="item.part_classification"
            :items="classificationOptions"
            item-text="text"
            item-value="value"
            label="Part Classification"
            clearable
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="submit" :loading="loading"
            >Submit</v-btn
          >
          <v-btn @click="dialog = false"> Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text">addAccountModal.vue</p>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      loading: false,
      classificationOptions: [
        { text: "Major Part", value: "major" },
        { text: "Minor Part", value: "minor" },
      ],
    };
  },

  methods: {
    ...mapActions({
      edit_item_type: "item_type/edit_item_type",
    }),
    async submit() {
      let x = await this.$confirm({
        title: "Edit Item Type",
        message: "Are you sure you want to proceed?",
        color: "primary",
        icon: "mdi-pencil",
      });
      if (x) {
        this.loading = true;
        try {
          await this.edit_item_type(this.item);
          this.$alert({
            title: "Success",
            message: "Successfully Edited",
            color: "success",
            icon: "mdi-check-circle",
          });
          this.dialog = false;
        } catch (err) {
          // error alert already shown by the store action
        }
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
